export const Eyebrow = ({ children, className = "", ...props }) => (
  <span className={`eyebrow ${className}`} {...props}>
    {children}
  </span>
);
